import config from "../config";

export default function basepath(path) {
  return config.BASE_URL + path;
}
